import { render, staticRenderFns } from "./EmployeeSalaries.vue?vue&type=template&id=4ee291f4&scoped=true&"
import script from "./EmployeeSalaries.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalaries.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSalaries.vue?vue&type=style&index=0&id=4ee291f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee291f4",
  null
  
)

export default component.exports